import { render, staticRenderFns } from "./PopUpProcessFile.vue?vue&type=template&id=2f621d12&scoped=true&"
import script from "./PopUpProcessFile.vue?vue&type=script&lang=js&"
export * from "./PopUpProcessFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpProcessFile.vue?vue&type=style&index=0&id=2f621d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f621d12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f621d12')) {
      api.createRecord('2f621d12', component.options)
    } else {
      api.reload('2f621d12', component.options)
    }
    module.hot.accept("./PopUpProcessFile.vue?vue&type=template&id=2f621d12&scoped=true&", function () {
      api.rerender('2f621d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpProcessFile.vue"
export default component.exports